import React from 'react';
import moment from 'moment';
const CalendarContext = React.createContext(
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
{});
export const useCalendarContext = () => React.useContext(CalendarContext);
export const CalendarProvider = ({ children }) => {
    const [active, setActive] = React.useState(moment().startOf('day').toISOString());
    const next = () => {
        setActive((active) => {
            const nextMonth = moment(active).add(1, 'month');
            const day = nextMonth.startOf('month').startOf('day').toISOString();
            return day;
        });
    };
    const prev = () => {
        setActive((active) => {
            const prevMonth = moment(active).subtract(1, 'month');
            const day = prevMonth.startOf('month').startOf('day').toISOString();
            return day;
        });
    };
    return (React.createElement(CalendarContext.Provider, { value: {
            active,
            setActive,
            next,
            prev
        } }, children));
};
//# sourceMappingURL=index.js.map